import * as React from 'react';
import { Field, WrappedFieldInputProps } from 'redux-form';
import JRCFormFieldRender, { FormInputProps, JRCWritableFormInputProps } from '../JRCFormFieldRender';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { ClickAwayListener } from '../../../Common/ClickAwayListener';
import { useControls } from '../ReduxFormControls';

const StyledInputColor = styled.input.attrs(() => ({ type: 'color' }))<FormInputProps>`
    &&& {
        width: 40px;
        height: 40px;
        border: none;
        padding: 0;
        margin: 0;
        cursor: pointer;
        border-radius: 8px;
        box-sizing: border-box;
        ::-webkit-color-swatch {
            border-color: transparent;
            border: none;
        }
        ::-moz-color-swatch {
            border-color: transparent;
            border: none;
        }
        ::-webkit-color-swatch-wrapper {
            padding: 0;
        }
    }
`;

const Container = styled.div`
    display: inline-flex;
    border-radius: 8px;
    overflow: hidden;
`;

/**
 * @deprecated Create a JRCInputColor instead
 */
const JRCFormColorFieldRender = (input: WrappedFieldInputProps, props: JRCWritableFormInputProps) => {
    const [, setOpen] = React.useState(false);

    React.useEffect(() => {
        if (input.value == '') input.onChange('#000000');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickAway = () => setOpen(false);

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Container>
                {/* dirty fix to go over a css legacy rule, will be refactored when component is designed */}
                <StyledInputColor id={props.name} {...input} />
            </Container>
        </ClickAwayListener>
    );
};

/**
 * Component used as a <input type="text"/>
 * @param props JRCWritableFormInputProps
 * validation props: required
 * @returns JSX.Element
 * @deprecated use JRCInputColor instead
 */
export const JRCFormColorField = (props: JRCWritableFormInputProps) => {
    const validate = useControls({
        intl: useIntl(),
        required: props.required,
    });
    return (
        <Field
            component={JRCFormFieldRender}
            renderInputFct={(input: WrappedFieldInputProps) => JRCFormColorFieldRender(input, props)}
            validate={validate}
            htmlFor={props.name}
            {...props}
        />
    );
};
